/** Šifrarnik vrsta troška se rijetko mijenja — dovoljno je jednom u pola sata. */
export const EXPENSE_TYPES_CACHE_TTL = 30 * 60 * 1000;
